import axios from 'axios';
import { API_URL } from '@/config';

export default {

  list(params) {
    return axios.get(`${API_URL}/otrs/tickets?${params}`);
  },

  create(data) {
    return axios.post(`${API_URL}/otrs/tickets`, data);
  },

  export() {
    window.open(`${API_URL}/otrs/tickets-export?extension=csv`, '_blank');
  },

  calculatePoolPrice(poolConfig) {
    return axios.post(`${API_URL}/vcloud/calculate-pool-price`, poolConfig);
  },

  addPool(data) {
    return axios.post(`${API_URL}/otrs/add-pool`, data);
  },

  editPool(data) {
    return axios.put(`${API_URL}/otrs/edit-pool`, data);
  },

  deletePool(data) {
    return axios.post(`${API_URL}/otrs/delete-pool`, data);
  },

  addEdge(data) {
    return axios.post(`${API_URL}/otrs/add-edge`, data);
  },
  editEdge(data) {
    return axios.put(`${API_URL}/otrs/edit-edge`, data);
  },
  addPublicIp(data) {
    return axios.post(`${API_URL}/otrs/add-public-ip`, data);
  },
  login(userForm) {
    return axios.post(`${API_URL}/otrs/login`, userForm);
  },

  maxValues() {
    return axios.get(`${API_URL}/otrs/tickets/max-values`);
  },

  verification_code() {
    return axios.post(`${API_URL}/otrs/send-verification-code`);
  }

};
